import type { Action, PayloadAction } from "@reduxjs/toolkit";
import * as actions from "./actions";
import type { IToggleFilters } from "./models";

const initialState: IToggleFilters = {
  activeFilters: {
    favorites: false,
    subscriptions: false,
  },
};

export default function subscriptionsReducer(
  state: IToggleFilters,
  action: Action,
): IToggleFilters {
  if (typeof state === "undefined") {
    return initialState;
  }
  switch (action.type) {
    case actions.UPDATE: {
      const subscriptions = (action as PayloadAction<IToggleFilters>).payload;
      return { ...subscriptions };
    }
    case actions.TOGGLE_FAVORITES: {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          favorites: (action as PayloadAction<boolean>).payload,
        },
      };
    }
    case actions.TOGGLE_SUBSCRIPTIONS: {
      return {
        ...state,
        activeFilters: {
          ...state.activeFilters,
          subscriptions: (action as PayloadAction<boolean>).payload,
        },
      };
    }
    default:
      return state;
  }
}
